import { BranchContinuationParameters } from "../Shared/Generated/BranchContinuationParameters";

export class BranchContinuationGuard {
    prepare(sourceUrl: string, landingUrl: string): "automatic" | "blocked" {
        const returned = [sourceUrl, landingUrl].some(value => Array.from(new URL(value).searchParams)
            .some(([name, flag]) => name.toLowerCase() === BranchContinuationParameters.returnMarker && flag === "true"));
        return returned ? "blocked" : "automatic";
    }
}
